(function () {
  'use strict';

  var config = window.SaturnBuilderConfig || {};
  var PRODUCT_ID = String(config.productId || '');
  var API_BASE = String(config.apiBase || 'https://ceramora-cashier-production.up.railway.app').replace(/\/$/, '');

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function imageUrlAtWidth(url, width) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url || '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function responsiveImageAttributes(url) {
    var source = url || '';
    var src = imageUrlAtWidth(source, 640);
    var attributes = 'src="' + escapeHtml(src) + '" loading="lazy" decoding="async"';
    if (source.indexOf('cdn.shopify.com') !== -1) {
      attributes += ' srcset="' + [240, 400, 640, 800].map(function (width) {
        return escapeHtml(imageUrlAtWidth(source, width)) + ' ' + width + 'w';
      }).join(', ') + '" sizes="(max-width: 760px) 31vw, 18vw"';
    }
    return attributes;
  }

  // Every form on the page that can add THIS product to the cart. The main product
  // form is only one of them: the theme also renders a quick-buy modal form
  // (product-form-quick-buy-<id>) and — the one that actually bit us — a one-click
  // "הוסף לעגלה" inside every product card, including the cards in the
  // recommended-products row on this very page. A set added from a card carries no
  // colours at all. Cards are matched by the variant in the form rather than by id,
  // because their ids come from whatever renders them.
  function findProductForms() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    var matches = [];
    for (var i = 0; i < forms.length; i++) {
      var id = forms[i].getAttribute('id') || '';
      var variantInput = forms[i].querySelector('input[name="id"]');
      var mine = id.indexOf('product-form-main-' + PRODUCT_ID) === 0
        || id.indexOf('product-form-quick-buy-' + PRODUCT_ID) === 0
        || (VARIANT_ID && variantInput && String(variantInput.value) === VARIANT_ID);
      if (mine && forms[i].querySelector('button[type="submit"]')) matches.push(forms[i]);
    }
    return matches;
  }

  // One shared fetch for the whole page: every form needs the same colours and the
  // same stock, and init() re-runs whenever the theme re-renders.
  var VARIANT_ID = '';
  var bundleDataPromise = null;
  function loadBundleData() {
    if (!bundleDataPromise) {
      bundleDataPromise = fetch(API_BASE + '/api/public/bundle-stock/' + PRODUCT_ID)
        .then(function (response) {
          if (!response.ok) throw new Error('Bundle data request failed');
          return response.json();
        })
        .then(function (payload) {
          if (!payload || !payload.sections || !payload.sections.length) throw new Error('Bundle data is incomplete');
          VARIANT_ID = String(payload.variantId || '');
          return payload;
        })
        .catch(function (error) {
          bundleDataPromise = null; // let a later pass try again
          throw error;
        });
    }
    return bundleDataPromise;
  }

  function cloneSlots(slots) {
    var copy = {};
    Object.keys(slots).forEach(function (key) { copy[key] = slots[key].slice(); });
    return copy;
  }

  function buildRecommended(sections, bundleQuantity) {
    var slots = {};
    sections.forEach(function (section, sectionIndex) {
      var count = section.neededPerBundle * bundleQuantity;
      var available = section.colors.filter(function (color) { return color.available > 0; });
      slots[section.key] = [];
      for (var i = 0; i < count; i++) {
        // Every shade at zero leaves nothing to recommend, and the modulo below
        // then divides by zero - which threw, and the whole builder died in the
        // catch at the bottom. A sold-out set read "we couldn't load the
        // colours" instead of "sold out" for as long as the bundle's own
        // level lagged its shades (up to one sync tick).
        var chosen = available.length
          ? available[(i + sectionIndex * section.neededPerBundle) % available.length]
          : null;
        slots[section.key].push(chosen ? chosen.name : null);
      }
    });
    return slots;
  }

  function colorFor(section, name) {
    for (var i = 0; i < section.colors.length; i++) {
      if (section.colors[i].name === name) return section.colors[i];
    }
    return null;
  }

  // Hide every real add-to-cart / express-checkout control tied to this form so
  // our two buttons are the only way to add to cart — otherwise a customer can
  // click the theme's own (still-visible) button and add the product with no
  // colors chosen. This has to include controls linked via the HTML `form="..."`
  // attribute, not just DOM nesting: the sticky add-to-cart bar renders its own
  // submit buttons that way, entirely outside this <form> element.
  //
  // `form.id` cannot be used to read that attribute: a <form> exposes its own
  // fields as properties, and this form has a hidden input named "id" (the
  // variant), so form.id IS that input element. Concatenating it into a selector
  // produced "[object HTMLInputElement]", matched nothing, and left every
  // out-of-form add-to-cart button visible and live all along.
  //
  // Re-run on every pass, not only on the first: the theme re-renders these
  // controls, and a freshly rendered button is a visible one.
  function hideNativeControls(form) {
    var formId = form.getAttribute('id') || '';
    var controls = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], [data-shopify="payment-button"]'));
    if (formId) {
      controls = controls.concat(Array.prototype.slice.call(
        document.querySelectorAll('button[type="submit"][form="' + formId + '"], [data-shopify="payment-button"][form="' + formId + '"]')
      ));
    }
    controls.forEach(function (control) {
      if (control.closest('.saturn-cta-group')) return;
      control.style.display = 'none';
    });
  }

  // The builder is the only way to buy a colour-choice set, but the theme still
  // renders the product's own variant swatches above it. On the sea-series bowls
  // that row is one live shade plus four that exist purely as supplier ordering
  // units (DSS09-DEN/WHI/RED/AQU) and read "sold out" forever — unbuyable, and
  // undeletable because orders.html points its catalog rows at those variants.
  // Hide the row instead. Scoped to the block that holds our own buttons so a
  // recommended-product card or quick-buy drawer on the same page keeps its
  // picker; single-variant sets render no picker at all, so this is a no-op there.
  function hideVariantPicker() {
    var cta = document.querySelector('.saturn-cta-group');
    if (!cta) return;
    var scope = cta.closest('.product-info') || cta.closest('form') || document;
    var pickers = scope.querySelectorAll('variant-picker, .variant-picker');
    Array.prototype.forEach.call(pickers, function (picker) {
      var block = picker.closest('.product-info__block-item') || picker;
      block.style.display = 'none';
    });
  }

  function init() {
    if (!PRODUCT_ID) return;
    findProductForms().forEach(function (form) {
      hideNativeControls(form);
      initForm(form);
    });
    hideVariantPicker();
  }

  function initForm(form) {
    if (form.querySelector('.saturn-builder-trigger')) return;

    var originalSubmit = form.querySelector('button[type="submit"]');
    var legacyTrigger = form.querySelector('.crm-bp-trigger');
    if (!originalSubmit) return;

    var quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      form.appendChild(quantityInput);
    }

    // Two buttons, clear hierarchy: primary always adds a fresh mixed
    // combo straight to the cart (no modal); secondary opens the exact
    // same picker as before for anyone who wants to choose their own
    // colors. The picker itself (openBuilder and everything inside it)
    // is untouched.
    var ctaGroup = document.createElement('div');
    ctaGroup.className = 'saturn-cta-group';
    ctaGroup.innerHTML =
      '<button type="button" class="saturn-builder-trigger saturn-cta-primary" disabled><span>טוען את הצבעים…</span></button>' +
      '<button type="button" class="saturn-cta-secondary" disabled>בחירת צבעים</button>';

    if (legacyTrigger) legacyTrigger.insertAdjacentElement('beforebegin', ctaGroup);
    else originalSubmit.insertAdjacentElement('beforebegin', ctaGroup);

    var defaultTrigger = ctaGroup.querySelector('.saturn-cta-primary');
    var customizeButton = ctaGroup.querySelector('.saturn-cta-secondary');

    var data = null;
    var slots = null;
    var bundleQuantity = 1;
    var overlay = null;
    var triggerBeforeOpen = null;
    var hiddenFloatingElements = [];
    var bodyOverflow = '';
    var message = '';
    var separateSets = false;
    var setSelections = [];
    var activeSetIndex = 0;

    function getQuantity() {
      var parsed = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      return parsed > 0 ? parsed : 1;
    }

    function resetForQuantity() {
      if (!data) return;
      bundleQuantity = getQuantity();
      syncSetSelections();
      if (overlay) render();
    }

    function sectionByKey(key) {
      for (var i = 0; i < data.sections.length; i++) {
        if (data.sections[i].key === key) return data.sections[i];
      }
      return null;
    }

    function usedCount(sectionKey, colorName, excludedIndex) {
      var count = 0;
      slots[sectionKey].forEach(function (name, index) {
        if (index !== excludedIndex && name === colorName) count++;
      });
      return count;
    }

    function requiredCountIfSelected(sectionKey, colorName, excludedIndex) {
      if (!separateSets) return usedCount(sectionKey, colorName, excludedIndex) * bundleQuantity + bundleQuantity;
      var count = 1;
      setSelections.forEach(function (setSlots, setIndex) {
        setSlots[sectionKey].forEach(function (name, index) {
          if (setIndex === activeSetIndex && index === excludedIndex) return;
          if (name === colorName) count++;
        });
      });
      return count;
    }

    function setMessage(text) {
      message = text || '';
      var element = overlay && overlay.querySelector('.saturn-builder__message');
      if (element) element.textContent = message;
    }

    // How many of this colour are currently in the set.
    function countIn(sectionKey, colorName) {
      var n = 0;
      slots[sectionKey].forEach(function (name) { if (name === colorName) n++; });
      return n;
    }

    // Which colour gives up a cup when the set is full and another is added:
    // whichever fills the most cups, and on a tie the one placed most
    // recently - so "+" always takes from the obvious place, never at random.
    function busiestOther(sectionKey, except) {
      var tally = {};
      slots[sectionKey].forEach(function (name) {
        if (name && name !== except) tally[name] = (tally[name] || 0) + 1;
      });
      var best = null, bestCount = 0, bestLast = -1;
      Object.keys(tally).forEach(function (name) {
        var last = slots[sectionKey].lastIndexOf(name);
        if (tally[name] > bestCount || (tally[name] === bestCount && last > bestLast)) {
          bestCount = tally[name];
          bestLast = last;
          best = name;
        }
      });
      return best;
    }

    function canAddColor(section, color) {
      if (!color || color.available <= 0) return false;
      if (requiredCountIfSelected(section.key, color.name, -1) > color.available) return false;
      if (slots[section.key].indexOf(null) !== -1) return true;
      return busiestOther(section.key, color.name) !== null;
    }

    function addColor(sectionKey, colorName) {
      var section = sectionByKey(sectionKey);
      var color = colorFor(section, colorName);
      if (!canAddColor(section, color)) return;

      var empty = slots[sectionKey].indexOf(null);
      if (empty !== -1) {
        slots[sectionKey][empty] = colorName;
      } else {
        var give = busiestOther(sectionKey, colorName);
        if (!give) return;
        slots[sectionKey][slots[sectionKey].lastIndexOf(give)] = colorName;
      }
      if (separateSets) setSelections[activeSetIndex] = slots;
      setMessage('');
      render();
    }

    function removeColor(sectionKey, colorName) {
      var at = slots[sectionKey].lastIndexOf(colorName);
      if (at === -1) return;
      slots[sectionKey][at] = null;
      if (separateSets) setSelections[activeSetIndex] = slots;
      setMessage('');
      render();
    }

    function missingCount() {
      var n = 0;
      data.sections.forEach(function (section) {
        slots[section.key].forEach(function (name) { if (!name) n++; });
      });
      return n;
    }

    // Neither photo set survives a naive crop - the sea-series shots are
    // hand-held and the shabtai ones are packshots with the cup small in
    // frame. The server sends where the cup actually sits in each photo.
    function frameStyle(color) {
      if (!color) return '';
      var x = color.posX == null ? 50 : color.posX;
      var y = color.posY == null ? 50 : color.posY;
      var zoom = color.zoom == null ? 1 : color.zoom;
      return 'object-position:' + x + '% ' + y + '%;transform:scale(' + zoom + ')';
    }

    // CSS auto-fit packs as many columns as fit and leaves the remainder
    // stranded - six colours across five columns is a row of five and one
    // lonely card. Spread the colours over as few rows as will fit and give
    // every row the same count instead, so a section always reads as a block.
    var PALETTE_MIN_CARD = 128;
    var PALETTE_GAP = 12;

    function layoutPalettes() {
      if (!overlay) return;
      Array.prototype.forEach.call(overlay.querySelectorAll('.saturn-palette'), function (palette) {
        var count = palette.children.length;
        if (!count) return;
        var width = palette.clientWidth;
        var fits = Math.max(1, Math.floor((width + PALETTE_GAP) / (PALETTE_MIN_CARD + PALETTE_GAP)));
        var rows = Math.ceil(count / Math.min(fits, count));
        var columns = Math.ceil(count / rows);
        palette.style.gridTemplateColumns = 'repeat(' + columns + ', minmax(0, 1fr))';
      });
    }

    function renderStage() {
      var container = overlay.querySelector('.saturn-builder__cups');

      container.innerHTML = data.sections.map(function (section) {
        var chosen = slots[section.key];
        var filled = chosen.filter(Boolean).length;

        var tray = chosen.map(function (name) {
          var color = colorFor(section, name);
          if (!color) return '<li class="saturn-tray__slot" aria-label="משבצת ריקה"></li>';
          return '<li class="saturn-tray__slot is-filled">' +
            '<img ' + responsiveImageAttributes(color.image) + ' alt="' + escapeHtml(color.name) + '" style="' + frameStyle(color) + '">' +
            '<span class="saturn-tray__dot" style="background:' + escapeHtml(color.hex) + '"></span>' +
          '</li>';
        }).join('');

        var cards = section.colors.map(function (color) {
          var n = countIn(section.key, color.name);
          var out = color.available <= 0;
          var addable = canAddColor(section, color);
          var low = !out && color.available <= 8;
          var attrs = ' data-section="' + escapeHtml(section.key) + '" data-color="' + escapeHtml(color.name) + '"';

          return '<article class="saturn-swatch' + (n ? ' is-chosen' : '') + (out ? ' is-out' : '') + '">' +
            '<button type="button" class="saturn-swatch__media"' + attrs + ' data-add="1"' + (addable ? '' : ' disabled') +
              ' aria-label="הוספת ' + escapeHtml(color.name) + (out ? ', אזל מהמלאי' : '') + '">' +
              '<img ' + responsiveImageAttributes(color.image) + ' alt="" style="' + frameStyle(color) + '">' +
              '<span class="saturn-swatch__badge" aria-hidden="true">' + n + '</span>' +
              (low ? '<span class="saturn-swatch__low">נותרו ' + color.available + '</span>' : '') +
              (out ? '<span class="saturn-swatch__out"><span>אזל</span></span>' : '') +
            '</button>' +
            '<div class="saturn-swatch__body">' +
              '<span class="saturn-swatch__chip" style="background:' + escapeHtml(color.hex) + '" aria-hidden="true"></span>' +
              '<span class="saturn-swatch__name">' + escapeHtml(color.name) + '</span>' +
            '</div>' +
            '<div class="saturn-stepper" dir="rtl">' +
              '<button type="button"' + attrs + ' data-step="-1"' + (n ? '' : ' disabled') + ' aria-label="הפחתת ' + escapeHtml(color.name) + '">−</button>' +
              '<span class="saturn-stepper__value' + (n ? '' : ' is-zero') + '">' + n + '</span>' +
              '<button type="button"' + attrs + ' data-step="1"' + (addable ? '' : ' disabled') + ' aria-label="הוספת ' + escapeHtml(color.name) + '">+</button>' +
            '</div>' +
          '</article>';
        }).join('');

        return '<section class="saturn-section">' +
          '<header class="saturn-section__head">' +
            '<span class="saturn-section__label">' + escapeHtml(section.label) + '</span>' +
            '<ul class="saturn-tray">' + tray + '</ul>' +
            '<span class="saturn-section__count">' + filled + ' מתוך ' + chosen.length + '</span>' +
          '</header>' +
          '<div class="saturn-palette">' + cards + '</div>' +
        '</section>';
      }).join('');

      layoutPalettes();

      Array.prototype.forEach.call(container.querySelectorAll('[data-add],[data-step]'), function (button) {
        button.addEventListener('click', function () {
          var sectionKey = button.getAttribute('data-section');
          var colorName = button.getAttribute('data-color');
          if (button.getAttribute('data-step') === '-1') removeColor(sectionKey, colorName);
          else addColor(sectionKey, colorName);
        });
      });
    }

    function syncSetSelections() {
      if (!separateSets) return;
      if (bundleQuantity < 2) {
        slots = cloneSlots(setSelections[0] || slots);
        separateSets = false;
        setSelections = [];
        activeSetIndex = 0;
        return;
      }
      while (setSelections.length < bundleQuantity) setSelections.push(cloneSlots(setSelections[0] || slots));
      if (setSelections.length > bundleQuantity) setSelections.length = bundleQuantity;
      activeSetIndex = Math.min(activeSetIndex, bundleQuantity - 1);
      slots = setSelections[activeSetIndex];
    }

    function renderSetMode() {
      if (!overlay) return;
      var toggle = overlay.querySelector('.saturn-builder__set-mode-toggle');
      var tabs = overlay.querySelector('.saturn-builder__set-tabs');
      toggle.hidden = bundleQuantity < 2;
      toggle.classList.toggle('is-active', separateSets);
      toggle.textContent = separateSets ? 'אותו שילוב בכל הסטים' : 'שילוב שונה לכל סט';

      tabs.hidden = bundleQuantity < 2;
      tabs.classList.toggle('is-placeholder', !separateSets && bundleQuantity >= 2);
      if (!separateSets || bundleQuantity < 2) {
        tabs.innerHTML = '';
        return;
      }

      tabs.innerHTML = setSelections.map(function (_, index) {
        return '<button type="button" class="saturn-builder__set-tab' + (index === activeSetIndex ? ' is-active' : '') + '" data-set-index="' + index + '">סט ' + (index + 1) + '</button>';
      }).join('');
      Array.prototype.forEach.call(tabs.querySelectorAll('[data-set-index]'), function (button) {
        button.addEventListener('click', function () {
          activeSetIndex = parseInt(button.getAttribute('data-set-index'), 10);
          slots = setSelections[activeSetIndex];
          render();
        });
      });
    }

    function toggleSeparateSets() {
      if (bundleQuantity < 2) return;
      if (separateSets) {
        slots = cloneSlots(setSelections[activeSetIndex] || slots);
        separateSets = false;
        setSelections = [];
        activeSetIndex = 0;
      } else {
        separateSets = true;
        activeSetIndex = 0;
        setSelections = [];
        for (var i = 0; i < bundleQuantity; i++) setSelections.push(cloneSlots(slots));
        slots = setSelections[0];
      }
      render();
    }

    function renderControls() {
      var messageElement = overlay.querySelector('.saturn-builder__message');
      if (messageElement) messageElement.textContent = message;

      var curated = overlay.querySelector('.saturn-builder__curated');
      var recommendedActive = isRecommendedSelection();
      curated.classList.toggle('is-active', recommendedActive);
      curated.setAttribute('aria-pressed', recommendedActive ? 'true' : 'false');
      curated.querySelector('[data-curated-label]').textContent = recommendedActive ? 'השילוב המומלץ שלנו' : 'חזרה לשילוב המומלץ';
      curated.querySelector('[data-curated-description]').textContent = '';
      renderQuantity();
      renderSetMode();
    }

    function render() {
      renderStage();
      renderControls();
    }

    function applyRecommended() {
      slots = buildRecommended(data.sections, 1);
      if (separateSets) setSelections[activeSetIndex] = slots;
      message = 'החזרנו את שילוב הצבעים המומלץ שלנו.';
      render();
    }

    function isRecommendedSelection() {
      var recommended = buildRecommended(data.sections, 1);
      return data.sections.every(function (section) {
        return slots[section.key].every(function (name, index) {
          return name === recommended[section.key][index];
        });
      });
    }

    function curatedSwatchesHtml() {
      var recommended = buildRecommended(data.sections, 1);
      var colors = [];
      data.sections.forEach(function (section) {
        recommended[section.key].slice(0, section.neededPerBundle).forEach(function (name) {
          var color = colorFor(section, name);
          if (color) colors.push(color.hex);
        });
      });
      return '<span class="saturn-builder__curated-swatches" aria-hidden="true">' + colors.map(function (hex) {
        return '<span class="saturn-builder__curated-swatch" style="background:' + escapeHtml(hex) + '"></span>';
      }).join('') + '</span>';
    }

    function brandLogoHtml(className) {
      var logoUrl = window.SaturnBuilderConfig && window.SaturnBuilderConfig.logoUrl;
      if (!logoUrl) return '<span class="' + className + ' saturn-builder__brand-wordmark">CERAMORA</span>';
      return '<img class="' + className + '" src="' + escapeHtml(logoUrl) + '" alt="Ceramora" decoding="async">';
    }

    function addPropertiesForSlots(targetSlots, qty, useSeparateSets, targetSetSelections) {
      Array.prototype.forEach.call(form.querySelectorAll('[data-saturn-builder-property], [data-crm-bundle-prop]'), function (input) {
        input.remove();
      });

      if (useSeparateSets) {
        targetSetSelections.forEach(function (setSlots, setIndex) {
          data.sections.forEach(function (section) {
            setSlots[section.key].forEach(function (name, cupIndex) {
              appendProperty('סט ' + (setIndex + 1) + ' · ' + section.label + ' ' + (cupIndex + 1), name);
            });
          });
        });
      } else {
        data.sections.forEach(function (section) {
          var propertyIndex = 0;
          for (var setIndex = 0; setIndex < qty; setIndex++) {
            targetSlots[section.key].forEach(function (name) {
              propertyIndex++;
              appendProperty(section.label + ' ' + propertyIndex, name);
            });
          }
        });
      }
    }

    function addProperties() {
      addPropertiesForSlots(slots, bundleQuantity, separateSets, setSelections);
    }

    // Primary button: always adds a freshly-computed recommended/mixed
    // combo for whatever quantity is currently set — independent of
    // anything customized (but not submitted) inside the picker.
    function addDefaultToCart() {
      if (!data || defaultTrigger.disabled) return;
      var qty = getQuantity();
      var defaultSlots = buildRecommended(data.sections, 1);
      addPropertiesForSlots(defaultSlots, qty, false, []);
      originalSubmit.click();
    }

    function appendProperty(label, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + label + ']';
      input.value = value;
      input.setAttribute('data-saturn-builder-property', '1');
      form.appendChild(input);
    }

    function setQuantity(value) {
      var next = Math.max(1, Math.min(20, value));
      bundleQuantity = next;
      if (quantityInput) {
        quantityInput.value = next;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncSetSelections();
      render();
    }

    function renderQuantity() {
      if (!overlay) return;
      var value = overlay.querySelector('.saturn-builder__quantity-value');
      var minus = overlay.querySelector('[data-quantity-action="minus"]');
      var addButton = overlay.querySelector('.saturn-builder__add');
      if (!value || !minus || !addButton) return;
      value.textContent = bundleQuantity === 1 ? 'סט אחד' : bundleQuantity + ' סטים';
      minus.disabled = bundleQuantity <= 1;

      // A cup can now be taken out and left empty, so the button states what
      // is still missing instead of letting an incomplete set reach the cart.
      var missing = missingCount();
      addButton.disabled = missing > 0;
      addButton.textContent = missing > 0
        ? (missing === 1 ? 'בחרו עוד כוס אחת' : 'בחרו עוד ' + missing + ' כוסות')
        : (bundleQuantity === 1 ? 'הוסיפו לעגלה' : 'הוסיפו ' + bundleQuantity + ' סטים לעגלה');

      var note = overlay.querySelector('[data-quantity-note]');
      if (note) note.textContent = bundleQuantity < 2 ? '' : (separateSets ? 'שילוב שונה לכל סט' : 'אותו שילוב בכל הסטים');
    }

    function closeBuilder() {
      if (!overlay) return;
      document.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('resize', layoutPalettes);
      document.body.style.overflow = bodyOverflow;
      hiddenFloatingElements.forEach(function (record) { record[0].style.display = record[1]; });
      hiddenFloatingElements = [];
      overlay.remove();
      overlay = null;
      if (triggerBeforeOpen) triggerBeforeOpen.focus();
    }

    function onKeyDown(event) {
      if (event.key === 'Escape') closeBuilder();
    }

    function openBuilder() {
      if (!data || overlay) return;
      if (bundleQuantity !== getQuantity()) resetForQuantity();

      triggerBeforeOpen = document.activeElement;
      bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      hiddenFloatingElements = [];
      Array.prototype.forEach.call(document.querySelectorAll('[id*="whatsapp" i], [class*="whatsapp" i], [id*="dondy" i], [class*="dondy" i]'), function (element) {
        hiddenFloatingElements.push([element, element.style.display]);
        element.style.display = 'none';
      });

      overlay = document.createElement('div');
      overlay.className = 'saturn-builder';
      overlay.innerHTML =
        '<div class="saturn-builder__dialog" dir="rtl" role="dialog" aria-modal="true" aria-label="בחירת הגוונים לסט" tabindex="-1">' +
          '<button type="button" class="saturn-builder__close" aria-label="סגירת בחירת הצבעים">×</button>' +
          '<div class="saturn-builder__layout">' +
            '<section class="saturn-builder__controls saturn-builder__header">' +
              '<div class="saturn-builder__heading">' +
                '<span class="saturn-builder__brand">' + brandLogoHtml('saturn-builder__brand-logo') + '</span>' +
                '<span class="saturn-builder__heading-copy">' +
                  '<h2 class="saturn-builder__title saturn-builder__primary-title">הרכיבו את הסט שלכם</h2>' +
                  '<p class="saturn-builder__subtitle">בחרו כמה כוסות מכל גוון</p>' +
                '</span>' +
              '</div>' +
              '<div class="saturn-builder__set-tabs-slot"><div class="saturn-builder__set-tabs" hidden></div></div>' +
            '</section>' +
            '<section class="saturn-builder__stage">' +
              '<div class="saturn-builder__cups"></div>' +
            '</section>' +
            '<section class="saturn-builder__controls saturn-builder__bottom">' +
              '<p class="saturn-builder__message" aria-live="polite"></p>' +
              '<div class="saturn-builder__bottom-row">' +
                '<button type="button" class="saturn-builder__curated" data-action="recommended" aria-pressed="true">' +
                  curatedSwatchesHtml() +
                  '<span class="saturn-builder__curated-copy"><strong data-curated-label>השילוב המומלץ שלנו</strong><small data-curated-description></small></span>' +
                  '<span class="saturn-builder__curated-check" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none"><path d="M3.25 8.25 6.4 11.4 12.75 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
                '</button>' +
                '<button type="button" class="saturn-builder__set-mode-toggle" hidden></button>' +
                '<div class="saturn-builder__quantity">' +
                  '<span class="saturn-builder__quantity-note" data-quantity-note></span>' +
                  '<div class="saturn-builder__stepper" dir="rtl">' +
                    '<button type="button" data-quantity-action="minus" aria-label="הפחתת סט">−</button>' +
                    '<span class="saturn-builder__quantity-value"></span>' +
                    '<button type="button" data-quantity-action="plus" aria-label="הוספת סט">+</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="saturn-builder__footer">' +
                '<button type="button" class="saturn-builder__add"></button>' +
              '</div>' +
            '</section>' +
          '</div>' +
        '</div>';

      document.body.appendChild(overlay);
      overlay.querySelector('.saturn-builder__close').addEventListener('click', closeBuilder);
      overlay.addEventListener('click', function (event) { if (event.target === overlay) closeBuilder(); });
      overlay.querySelector('[data-action="recommended"]').addEventListener('click', applyRecommended);
      overlay.querySelector('[data-quantity-action="minus"]').addEventListener('click', function () { setQuantity(bundleQuantity - 1); });
      overlay.querySelector('[data-quantity-action="plus"]').addEventListener('click', function () { setQuantity(bundleQuantity + 1); });
      overlay.querySelector('.saturn-builder__set-mode-toggle').addEventListener('click', toggleSeparateSets);
      overlay.querySelector('.saturn-builder__add').addEventListener('click', function () {
        addProperties();
        closeBuilder();
        customizeButton.classList.add('is-complete');
        customizeButton.textContent = 'נוסף לעגלה — עריכת הצבעים';
        originalSubmit.click();
      });

      document.addEventListener('keydown', onKeyDown);
      window.addEventListener('resize', layoutPalettes);
      render();
      overlay.querySelector('.saturn-builder__dialog').focus({ preventScroll: true });
    }

    defaultTrigger.addEventListener('click', addDefaultToCart);
    customizeButton.addEventListener('click', openBuilder);
    if (quantityInput) {
      quantityInput.addEventListener('input', resetForQuantity);
      quantityInput.addEventListener('change', resetForQuantity);
    }

    loadBundleData()
      .then(function (payload) {
        data = payload;
        bundleQuantity = getQuantity();
        slots = buildRecommended(data.sections, 1);
        // The theme's own button is the truth about whether this variant can be
        // bought at all. When it says sold out it is also disabled, and clicking
        // it from here does nothing at all - a button that looks alive and
        // silently swallows the click is worse than one that says why.
        // ...and the same lag the other way round: the theme's button can still
        // say "add to cart" while every shade is gone. Nothing could be packed
        // from that, so it counts as sold out here too.
        var noShadesLeft = data.sections.some(function (section) {
          return !section.colors.some(function (color) { return color.available > 0; });
        });
        if (originalSubmit.disabled || noShadesLeft) {
          defaultTrigger.disabled = true;
          customizeButton.disabled = true;
          defaultTrigger.querySelector('span').textContent = noShadesLeft
            ? 'אזל מהמלאי'
            : (originalSubmit.textContent.trim() || 'אזל מהמלאי');
          return;
        }
        defaultTrigger.disabled = false;
        customizeButton.disabled = false;
        defaultTrigger.querySelector('span').textContent = 'הוסף לעגלה';
      })
      .catch(function () {
        defaultTrigger.disabled = true;
        customizeButton.disabled = true;
        defaultTrigger.querySelector('span').textContent = 'לא הצלחנו לטעון את הצבעים — נסו לרענן';
      });
  }

  // The theme re-renders the whole product-info block (<product-rerender
  // observe-form="product-form-main-...">) on a quantity change, a variant change
  // and whenever it refetches stock. That wipes our two buttons and brings the
  // theme's own add-to-cart back to life - and that button puts the set in the
  // cart with no colours chosen at all, which is how #8728 and #9202 reached us
  // with zero properties and deducted nothing. init() is cheap to re-run: it
  // returns immediately while our trigger is still in place, so watching every
  // mutation just means the buttons grow back the moment they're removed.
  var reinitTimer = null;
  function scheduleInit() {
    if (reinitTimer) return;
    reinitTimer = setTimeout(function () {
      reinitTimer = null;
      try { init(); } catch (error) {}
    }, 60);
  }

  function start() {
    init();
    if (window.MutationObserver) {
      new MutationObserver(scheduleInit).observe(document.body, { childList: true, subtree: true });
    }
    // Belt and braces for a re-render that somehow doesn't touch the DOM we watch.
    setInterval(scheduleInit, 2000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
